import { render, staticRenderFns } from "./MyPointsDefaultModel.vue?vue&type=template&id=4a528d41&"
import script from "./MyPointsDefaultModel.js?vue&type=script&lang=js&"
export * from "./MyPointsDefaultModel.js?vue&type=script&lang=js&"
import style0 from "./MyPointsDefaultModel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCol,VIcon})
